const handleValidateRoleChange = e =>
  document.getElementById('organization-role').style.display =
  e.target.checked ? 'block' : 'none'

const handleLogoImgChange = e =>
  document.getElementById('logo-preview').style.backgroundImage =
  e.target.files[0] ? `url('${URL.createObjectURL(e.target.files[0])}')` : ''

const init = () => {
  // Show 'role' input text if affiliated with nonprofit, else hide
  const validateRole = document
  .getElementById('organization_request_contact_attributes_validate_role')
  validateRole.addEventListener('change', handleValidateRoleChange)
  handleValidateRoleChange({ target: validateRole })

  // Show thumbnail of uploaded file
  document
  .getElementById('organization_request_organization_attributes_logo_img')
  .addEventListener('change', handleLogoImgChange)
}

document.addEventListener('DOMContentLoaded', init)
